// extracted by mini-css-extract-plugin
module.exports = {"rounded_full":"Charts_rounded_full__31zHr","chart_legend":"Charts_chart_legend__be2_v","chart_title":"Charts_chart_title__14d0C","chart_wrapper":"Charts_chart_wrapper__1QGum"};